<div class="fb-norway-eol-dialog-plugin" hive-root>
    <div class="fb-norway-eol-dialog-plugin__title-section">
        <h6 class="fb-norway-eol-dialog-plugin__title">
            Recommendation Details for
            <b>{{ renderInfo().targetName }}</b>
        </h6>
        <div class="fb-norway-eol-dialog-plugin__guidance"> Contact your account team to upgrade </div>
    </div>
    <div class="fb-norway-eol-dialog-plugin__body">
        <div class="fb-norway-eol-dialog-plugin__message">This appliance is approaching end-of-life</div>
        <table class="fb-norway-eol-dialog-plugin__table">
            <thead>
                <tr>
                    <th colspan="2">Appliance Details</th>
                </tr>
            </thead>
            <tbody>
                <tr class="fb-norway-eol-dialog-plugin__row">
                    <th class="fb-norway-eol-dialog-plugin__label" scope="row">Current model</th>
                    <td class="fb-norway-eol-dialog-plugin__value">{{ renderInfo().currentModel }}</td>
                </tr>
                @if (renderInfo().eolDate) {
                    <tr class="fb-norway-eol-dialog-plugin__row">
                        <th class="fb-norway-eol-dialog-plugin__label" scope="row">End-of-support date</th>
                        <td class="fb-norway-eol-dialog-plugin__value">
                            {{ renderInfo().eolDate | date: 'MMMM d, yyyy' : 'UTC' }}
                        </td>
                    </tr>
                }
            </tbody>
        </table>
    </div>
    <footer class="fb-norway-eol-dialog-plugin__footer">
        @if (renderInfo().allowDismiss) {
            <hive-button
                label="Dismiss Recommendation"
                emphasis="secondary"
                [disabled]="!renderInfo().allowDismiss() || renderInfo().actionInProgress()"
                hiveTooltip
                [hiveTooltipDescription]="renderInfo().allowDismiss() ? '' : 'Operation not permitted'"
                (click)="handleActionEvent(RecommendationActionEvent.DISMISS)"
            ></hive-button>
        }
        <hive-button
            label="Cancel"
            emphasis="secondary"
            [disabled]="renderInfo().actionInProgress()"
            (click)="handleActionEvent(RecommendationActionEvent.CANCEL)"
        ></hive-button>
        <hive-button
            label="Contact Account Team"
            emphasis="primary"
            [isLoading]="renderInfo().actionInProgress()"
            [disabled]="!renderInfo().allowContactAccountTeam() || renderInfo().actionInProgress()"
            hiveTooltip
            [hiveTooltipDescription]="renderInfo().allowContactAccountTeam() ? '' : 'Operation not permitted'"
            (click)="handleActionEvent(RecommendationActionEvent.CONTACT_ACCOUNT_TEAM)"
        ></hive-button>
    </footer>
</div>
